import EditableSelect from './EditableSelect';
import EditableSelectField from './EditableSelectField';
EditableSelect.Field = EditableSelectField;
export default EditableSelect;
//# sourceMappingURL=index.js.map